export const breadcrumb = {
  stats: {
    title: 'Statistics',
    general: 'Common',
    detailed: 'Detailed'
  }
};
